import React from 'react';

import { validateCurrentInput } from '../utils/Validations';

interface IEvePriceCalculatorInputProps {
    label: string;
    inputName: string;
    value: string;
    errorText: string;
    onChange: (name: string, value: string) => void;
}

export const EvePriceCalculatorInput: React.FC<IEvePriceCalculatorInputProps> = props => {
    const { label, inputName, value, errorText, onChange } = props;
    const className = `eve-price-calculator-display__form-row-${inputName}`;

    /**
     * Emits input change
     * @param e Event
     */
    const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>): void => onChange(e.target.name, e.target.value);

    return (
        <div className={`${className}`}>
            <label className={`${className}--label`} htmlFor={inputName}>
                {label}
            </label>
            <input
                type='text'
                id={inputName}
                className={`${className}--input`}
                name={inputName}
                value={value}
                defaultValue=''
                onChange={handleOnChange}
            />
            {validateCurrentInput(value) ? <></> : <div className={`${className}--error`}>{errorText}</div>}
        </div>
    );
};
